import $ from 'jquery';
import Ps from 'perfect-scrollbar';
import debounce from './utils/debounce';

class Filters {
    constructor (wrapperClass) {
        this.$wrapper     = $(wrapperClass);
        this.wrapperClass = wrapperClass;
        this.speed        = 300;

        // Selectors
        //----------------------------------------
        // Filter Selectors
        this.$form           = this.$wrapper.find(`${this.wrapperClass}__form`).not(`.c-active-filters ${this.wrapperClass}__form`);
        this.$filters        = this.$wrapper.find(`${this.wrapperClass}__filter`);
        this.$filterHeadings = this.$wrapper.find(`${this.wrapperClass}__filter__heading`);
        this.$filterLists    = this.$wrapper.find(`${this.wrapperClass}__filter__list`);
        this.$checkboxes     = this.$wrapper.find(`${this.wrapperClass}__filter__list__item__checkbox`);
        this.$reset          = $(`${this.wrapperClass}__clear`);
        this.$submit         = this.$wrapper.find(`${this.wrapperClass}__submit`);
        this.$buttons        = this.$form.find('button');

        // Active Filter Selectors
        this.$activeFilters = $('.js-active-filter');

        // Events
        //----------------------------------------
        // Filter Events
        this.$checkboxes.on('click', $.proxy(this.checkboxChange, this));
        this.$filterHeadings.on('click', $.proxy(this.headingClick, this));
        this.$reset.on('click', $.proxy(this.resetClick, this));
        this.$submit.on('click', $.proxy(this.submitClick, this));
        $(document).on('click', $.proxy(this.documentClick, this));

        // Active Filter Events
        this.$activeFilters.on('click', $.proxy(this.activeFilterClick, this));

        // Escape Key
        $(document).keyup((e) => {
            if (e.keyCode === 27) {
                this.closeFilters(this.$filters);
            }
        });

        // Scrollbars
        //----------------------------------------
        this.scrollbars = [];

        this.addScrollbars();

        // Filter Counts
        //----------------------------------------
        this.addCountToHeadings();
        this.checkAllForCheckedItems();

        $(window).on('resize', $.proxy(this.closeAllFilters, this));

        $(window).on('resize', debounce(() => {
            this.updateScrollbars();
        }, 300)).on('load', () => {
            // Add clears after every 4 filters
            this.$filters.filter(':nth-child(4n)').after('<div class="u-clear"></div>');
        });

        this.disableButtons();
    }

    addScrollbars () {
        for (let i = 0; i < this.$filterLists.length; i++) {
            this.scrollbars.push(new Ps(this.$filterLists[i]));
        }
    }

    updateScrollbars () {
        this.scrollbars.forEach((ps) => ps.update());
    }

    checkAllForCheckedItems () {
        // Check for active
        for (let i = 0; i < this.$filters.length; i++) {
            const $filter = $(this.$filters[i]);

            this.checkForCheckedItems($filter);
        }
    }

    checkForCheckedItems ($filter) {
        if ($filter.find(':checked').length) {
            $filter.addClass('is-active');
        } else {
            $filter.removeClass('is-active');
        }

        this.updateCountString($filter);
    }

    resetForm ($form) {
        $form.find(`${this.wrapperClass}__filter__list__item__checkbox`).prop('checked', false);
        $form.find(`${this.wrapperClass}__hidden-input`).val('');

        this.checkAllForCheckedItems();
    }

    checkboxChange (e) {
        const $elem   = $(e.target);
        const $filter = $elem.closest(`${this.wrapperClass}__filter`);

        this.checkForCheckedItems($filter);
        this.enableButtons();

        if (this.submitOnChange) {
            this.submitForm();
        }
    }

    headingClick (e) {
        const $elem   = $(e.target);
        const $filter = $elem.closest(`${this.wrapperClass}__filter`);

        this.closeFilters(this.$filters.not($filter));

        $filter.toggleClass('is-open').find(`${this.wrapperClass}__filter__list`).slideToggle(this.speed, () => {
            this.updateScrollbars();
        });
    }

    documentClick (e) {
        const $elem = $(e.target);

        if (!$elem.closest(`${this.wrapperClass}__filter__list`).length && !$elem.closest(`${this.wrapperClass}__filter`).length) {
            this.closeFilters(this.$filters);
        }
    }

    closeFilters ($filters) {
        $filters.removeClass('is-open').find(`${this.wrapperClass}__filter__list`).slideUp(this.speed);
    }

    closeAllFilters () {
        this.$filters.removeClass('is-open').find(`${this.wrapperClass}__filter__list`).slideUp(this.speed);
    }

    resetClick () {
        this.resetForm(this.$form);

        this.$form.submit();
    }

    submitClick (e) {
        const $elem = $(e.target);
        const $form = $elem.closest(`${this.wrapperClass}__form`);

        this.backToFirstPage();

        $form.submit();
    }

    submitForm () {
        this.backToFirstPage();
        this.$form.submit();
    }

    backToFirstPage () {
        // Go to Page 1 when new filter clicked
        let formLocation;
        const $parentForm = this.$submit.parents('form');
        const $hiddenPage = $parentForm.find('[name="hidden-current-page"]');

        formLocation = window.location.href;
        formLocation = formLocation.replace(/(hidden-current-page=\d+)/, '');
        formLocation = formLocation.replace(/(current-page=\d+)/, '');

        $parentForm.prop('action', formLocation);

        if ($hiddenPage.length > 0) {
            $hiddenPage.val(1);
        } else {
            $parentForm.append('<input type="hidden" name="hidden-current-page" value="1" />');
        }
    }

    activeFilterClick () {
        this.submitOnChange = true;
    }

    addCountToHeadings () {
        this.$filterHeadings.find(':first-child').before('<span class="c-filters__filter__heading__count js-filters__filter__heading__count"></span>');
    }

    updateCountString ($filter) {
        let countString = '';

        if ($filter.find(':checked').length) {
            countString = `${$filter.find(':checked').length} selected`;
        }

        $filter.find(`${this.wrapperClass}__filter__heading__count`).text(countString);
    }

    // Disable buttons if nothing is checked
    disableButtons () {
        if (!this.$checkboxes.filter(':checked').length) {
            this.$buttons.addClass('is-disabled');
        }
    }

    enableButtons () {
        this.$buttons.removeClass('is-disabled');
    }
}

export default Filters;
